import type { FaireProductEntity } from "../../entity_types/product";

export const p_nugy9ugp84: FaireProductEntity = {
  token: "p_nugy9ugp84",
  type: "product",
  name: "8\" x 6\" x 4\" Shipping Boxes - Bundle of 25",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/9eaa8512881615631606163028bb95c4cbe36567406a339d12c786238f629718.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d822d09edd2b7a13394872c66fa16a1d5d322af549f5950d5ac16016e001da61.jpeg",
    "https://cdn.faire.com/fastly/f7f644c660be46f9f3def7c6aa68c25cb2d2a138e6ea3ba125505d5f8d91564e.jpeg",
    "https://cdn.faire.com/fastly/d12f3f8c8e5025a5e159061746a762f99e5eea5d3113b755013f27b2f6ee002d.jpeg"
  ],
  priceDollars: 12.5,
  description: "Durable 8\" x 6\" x 4\" corrugated shipping boxes for accessories, gifts and smaller retail products. The compact size helps minimize unused space inside the package.\n\n- Size: 8\" L x 6\" W x 4\" H\n- Material: corrugated\n- Folds into shape quickly and seals with packing tape\n- Ships and stores flat to save space\n- Quantity: 25 boxes per bundle\n\nKeep a ready supply on hand for customer orders, store transfers and storage.",
  tags: [],
  msrpDollars: 18.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:17.453Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
